import { useContactNameAffixSuggestionsQuery } from './NameAffixSuggestions.graphql.generated';
import type { NameAffixSuggestionsState } from './NameAffixField.types';

/**
 * Locale-keyed prefix/suffix suggestions for the Title/Suffix fields. Call once
 * at Form level and fan the result out to every ContactInfo row — the list is
 * per event, not per household member.
 *
 * @param eventId Skips the query entirely when absent (name-affix fields off).
 * @param contactCollectionId Capability token for the public guest contact
 * collector — lets the query resolve without a session. Omitted in admin
 * surfaces, where the logged-in event admin authorizes the query instead.
 */
export function useNameAffixSuggestions(eventId: string | null | undefined, contactCollectionId?: string): NameAffixSuggestionsState {
  const { data, loading } = useContactNameAffixSuggestionsQuery({
    variables: { eventId: eventId ?? '', contactCollectionId },
    batchMode: 'fast',
    ssr: false,
    skip: !eventId,
  });

  return { suggestions: data?.contactNameAffixSuggestions, loading };
}
